import { FlashMessages } from '../components/Flash/redux/flash-messages';

const reportedErrorMessage = {
  type: 'danger',
  message: FlashMessages.NotRight
};

export default reportedErrorMessage;
